import styled from 'styled-components';
import { palette } from '../../theme/colors';

export const SContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 1rem;
  border-bottom: 1px solid;
`;

export const SIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.875rem;
  height: 1.875rem;
  flex-shrink: 0;
  border-radius: 0.5rem;

  svg {
    color: ${palette.white};
  }
`;

export const SInstructionsText = styled.p`
  flex: 1;
  margin: 0;
  font-family: 'Roboto-Regular';
  font-size: 1rem;
  line-height: 1.3125rem;
  color: ${palette.white};
  white-space: pre-wrap;
`;
